export default __webpack_public_path__ + "static/media/Rectangle1.7dcb34d9.jpg";